module.exports = __webpack_public_path__ + "img/reactbook.a67545eb.png";